<template >
<div >
    <head-nav></head-nav>

    <div class="form-pass">
        <img src="../../img/mission-logo.png" style="max-width:300px; margin-left: -11px">
        <br>
        <br>
        <span style=" font-family: 'lemon_milkregular';padding-top:15px;padding-bottom:15px">
            Please define a new password
        </span>
        <br>
        <br>
        <form class="login-form" @submit.prevent="resetPassword" >
            <input name="password" placeholder="New Password" type="password"  v-model="newPassword">
             <span class="al" >Password must have at least 8 characters.</span>
            <input name="password" placeholder="Confirm Password" type="password"  v-model="confirmPassword">
            <button class="btn btn-dark" name="submit" type="submit">Submit</button>
        </form>
            <br>
            <a class="message" href="/Login">Back to website</a>
    </div>
     <info></info> 
</div>
</template>
<script>
  import { auth } from '@/firebase';
  import firebase from '@/firebase'; // Importar Firebase

  import headNav from "../../components/navBar";
  import info from "../../components/info";
  import swal from "sweetalert";
  
  export default {
    components: {
      headNav,
      info,
    },
    data() {
      return {
        token: this.$route.query.oobCode || "", // Captura el token desde la URL
        newPassword: "",
        confirmPassword: "",
      };
    },
    methods: {
      async resetPassword() {
        if (this.newPassword !== this.confirmPassword) {
          swal("Error", "Passwords do not match!", "error");
          return;
        }
  
        try {
          // Verificar el código de restablecimiento
          const email = await auth.verifyPasswordResetCode(this.token);
          console.log("Correo asociado al token:", email);
  
          // Confirmar el restablecimiento de contraseña
          await auth.confirmPasswordReset(this.token, this.newPassword);
          swal("Success", "Password has been reset successfully!", "success");
  
          // Redirigir al usuario después del éxito
          this.$router.push("/login");
        } catch (error) {
          console.error("Error resetting password:", error.message);
          swal("Error", error.message, "error");
        }
      },
    },
  };
</script> 
  
<style >

.form-pass {
    position: relative;
    z-index: 1;
    background: #FFFFFF;
    max-width: 580px;
    max-height: 580px;
    margin: 20px auto 40px;
    padding: 45px;
    text-align: center;
    box-shadow: 0 0 20px 0 rgba(0, 0, 0, 0.2), 0 5px 5px 0 rgba(0, 0, 0, 0.24);
}

.form-pass input {
    font-family: 'berleno';
    outline: 0;
    background: #f2f2f2;
    width: 100%;
    border: 0;
    margin: 0 0 15px;
    padding: 15px;
    box-sizing: border-box;
    font-size: 14px;
}

.form-pass button {
    font-family: 'lemon_milkregular';
    text-transform: uppercase;
    outline: 0;  
    width: 100%;
    border: 0;
    padding: 15px;
    color: #FFFFFF;
    font-size: 14px;
    -webkit-transition: all 0.3 ease;
    transition: all 0.3 ease;
    cursor: pointer;
}


.form-pass .message {
    margin: 5px 0 0;
    color: #212529;
    font-size: 15px;
    text-decoration: none;
}
.form-pass .al {
    margin: 15px 0 0;
    color: #212529;
    font-size: 11px;
    text-decoration: none;
}


</style>